module.exports = __webpack_public_path__ + "img/02012862001565.9527d1c7.png";